import { render, staticRenderFns } from "./crearEncuesta.vue?vue&type=template&id=0164d34f&scoped=true&"
import script from "./crearEncuesta.vue?vue&type=script&lang=js&"
export * from "./crearEncuesta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0164d34f",
  null
  
)

export default component.exports